import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcomeDeposit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.41667 13.7499V9.58328H5.26829H3.96501H0L0 13.7499H3.96501H5.41667Z",
			fill: "#A3B8C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5 24.1666V18.3333H18.3333V24.1666H15L20.4167 30L25.8333 24.1667L22.5 24.1666Z",
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6667 22.5414V16.6667H17.8677H19.0688H21.4709H24.1667V22.5414H30.5323V0H20.3549H10.1774H0V8.33333H3.2754H6.55958V15H3.2754H0V22.5414H10.1774H16.333H16.6667Z",
			fill: "#A3B8C2"
		})
	]
});
export default SvgWelcomeDeposit;
